export default {
      id: "tile-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#tile",
      toString: function () {
        return this.url;
      }
    }